/**
 * @generated SignedSource<<1c8e2786f37ec89f823a315d3db55e81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue">;
  readonly " $fragmentType": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue";
};
export type issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue$key = {
  readonly " $data"?: issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "c07bf95905363410cf22a75dbe9a1754";

export default node;
